import { UserType } from '../../Types/UsersType';

export const usersState = {
  users: [] as UserType[],
  disabled: false,
  error: null as null | string,
};
export type UsersStateType = typeof usersState;
